module.exports = __webpack_public_path__ + "img/CM-SL-CA-Nissan-Established.c27ba764.jpeg";